import React, { useEffect, useState } from "react";
import { CardTitle, Spinner } from "reactstrap";
import {
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  PaginationComponent,
  PreviewAltCard,
  UserAvatar,
} from "../../../components/Component";
import { carerBirthdaysAPI } from "./DashboardData";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CarerBirthdays = () => {
  const history = useHistory();
  const itemsPerPage = 10;
  const [type, setType] = useState("TODAY");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    loadCarerBirthdays();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, type]);

  const loadCarerBirthdays = () => {
    setLoading(true);
    carerBirthdaysAPI(
      {
        pageInfo: { pageIndex: currentPage, itemsPerPage },
        type,
      },
      (response, error) => {
        if (!error) {
          setData(response?.list || []);
          setTotalItems(response?.pageInfo?.totalItems ?? 0);
        }
        setLoading(false);
      }
    );
  };

  const handleTypeChange = (newType) => {
    if (type !== newType) setType(newType);
  };

  const tabs = [
    { id: "TODAY", label: "Today" },
    { id: "MONTH", label: "Current Month" },
  ];

  const headers = [
    { size: "sm", label: "Carer" },
    { size: "md", label: "Phone" },
    { size: "sm", label: "Turning Age" },
    { size: "md", label: "Birthday" },
  ];

  return (
    <>
      <div className="card-inner border-bottom">
        <div className="card-title-group">
          <CardTitle>
            <h6 className="title">Carer Birthdays</h6>
          </CardTitle>
          <div className="card-tools">
            <ul className="card-tools-nav">
              {tabs.map((tab) => (
                <li key={tab.id} className={type === tab.id ? "active" : ""} onClick={() => handleTypeChange(tab.id)}>
                  <a href={`#${tab.id.toLowerCase()}`} onClick={(e) => e.preventDefault()}>
                    <span>{tab.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="spinner-container">
          <Spinner className="spinner-border-md" color="primary" />
        </div>
      ) : data?.length > 0 ? (
        <DataTableBody bodyclass="nk-tb-orders">
          <DataTableHead>
            {headers.map((h, i) => (
              <DataTableRow key={i} size={h.size}>
                <span>{h.label}</span>
              </DataTableRow>
            ))}
          </DataTableHead>
          {data.map((item, idx) => (
            <DataTableItem
              key={idx}
              className="cursor-pointer"
              onClick={() =>
                history.push({
                  pathname: `${process.env.PUBLIC_URL}/carer-detail`,
                  state: { id: item.id },
                })
              }
            >
              <DataTableRow size="sm">
                <div className="user-card">
                  <UserAvatar
                    size="sm"
                    theme={item?.theme}
                    customHex={item?.colourHex}
                    text={`${item?.firstName?.charAt(0) || ""}${item?.lastName?.charAt(0) || ""}`.toUpperCase()}
                    image={item?.profileImg?.imageUrl ?? ""}
                    name={`${item?.firstName} ${item?.lastName}`}
                  />
                </div>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="tb-sub one-line-ellipsis">
                  {item?.phone && item?.countryCode ? `+${item.countryCode}-${item.phone}` : item?.phone || "-"}
                </span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="tb-sub">{item?.turningAge || "-"}</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="tb-sub one-line-ellipsis">{moment(item?.birthDate).format("DD MMM")}</span>
              </DataTableRow>
            </DataTableItem>
          ))}
        </DataTableBody>
      ) : (
        <div className="no-data-text align-middle">
          <PreviewAltCard className="m-3">
            <div className="text-center">
              <p>There are no records found.</p>
            </div>
          </PreviewAltCard>
        </div>
      )}

      {totalItems > itemsPerPage && (
        <div className="mx-4 mb-4" style={{ marginTop: "auto" }}>
          <PaginationComponent
            itemPerPage={itemsPerPage}
            totalItems={totalItems}
            paginate={setCurrentPage}
            currentPage={currentPage}
          />
        </div>
      )}
    </>
  );
};

export default CarerBirthdays;
